import useIsMounted from 'ismounted'
import { useEffect, useState } from 'react'

import { Embed } from 'almanac-ui/icons'
import { ReactComponent as Hyperlink } from 'assets/icons/hyperlink.svg'
import { FormatBar } from 'common/Prose/components/FormatBar/FormatBar'
import { getURLMetadata, IframelyData } from 'components/Handbook2_0/Sidebar/HandbookItemTypes/getURLMetadata'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

type Attrs = Record<string, string | number>

interface Props {
  attrs: Attrs
}

export const FormatMenu = ({ attrs }: Props) => {
  const [urlMetaData, setUrlMetaData] = useState<IframelyData | null>(null)
  const isMounted = useIsMounted()
  const newFormatBar = useFlipperFlag('new_inline_format_bar')

  useEffect(() => {
    const fetchData = async () => {
      const meta = await getURLMetadata(attrs.url as string)

      if (meta && 'links' in meta) {
        isMounted.current && setUrlMetaData(meta)
      } else {
        isMounted.current && setUrlMetaData(null)
      }
    }

    fetchData()
  }, [isMounted, attrs.url])

  const defaultIcon = () => (newFormatBar ? Embed : Hyperlink)

  return (
    <FormatBar
      icon={urlMetaData?.links?.icon?.[0]?.href ?? defaultIcon()}
      subtitle={urlMetaData?.meta?.title ? (attrs.url as string) : undefined}
      title={urlMetaData?.meta?.title ?? (attrs.url as string)}
      url={attrs.url as string}
      mode={'inline'}
    />
  )
}
